<template>
	<div class="userInfo-container">
		<div class="userInfo-title">
			<span>基本信息</span>
			<span class="flex-empty"></span>
			<a-button v-if="!isEditStatus" class="fr" icon="edit" @click="isEditStatus = true">编辑</a-button>
			<div v-else>
				<a-button type="primary" class="fr" @click="updateUserInfo">提交</a-button>
				<a-button class="fr m-right-20" @click="resetHandle">取消</a-button>
			</div>
		</div>

		<div class="userInfo-content" v-if="isEditStatus">
			<div>
				<a-upload :customRequest="customRequest" list-type="picture-card"
					:show-upload-list="false">
					<span v-if="avatarUrl" class="userInfo-avatar"
						:style="getBgStyle(avatarUrl)">
					</span>
					<div v-else class="userInfo-avatar">
						<svg-icon iconClass="photo"></svg-icon>
					</div>
				</a-upload>
				<p class="userInfo-avatar_tips" v-if="avatarUrl">点击图片修改头像</p>
			</div>
			<div class="userInfo-right">
				<div class="userInfo-item">
					<span class="userInfo-label">手机号</span>
					<span class="userInfo-item_value">{{ userInfo.mobile }}</span>
				</div>
				<div class="userInfo-item">
					<span class="userInfo-label">姓名</span>
					<a-input class="userInfo-input" v-model="userName" placeholder="请输入姓名" />
				</div>
			</div>
		</div>

		<div class="userInfo-content" v-else>
			<div>
				<span v-if="userInfo.avatar_url" class="userInfo-avatar" :style="getBgStyle(avatarUrl)" @click="viewPhoto([userInfo])"></span>
				<span v-else class="userInfo-avatar" :style="getBgStyle(avatar)"></span>
			</div>
			<div class="userInfo-right">
				<div class="userInfo-item width-100p">
					<span class="userInfo-label userInfo-item_label">手机号</span>
					<span class="userInfo-item_value">{{ userInfo.mobile }}</span>
				</div>
				<div class="userInfo-item">
					<span class="userInfo-label userInfo-item_label">姓名</span>
					<span class="userInfo-item_value">{{ userName }}</span>
				</div>
			</div>
		</div>
		<app-view-img :imageList.sync="imageList" :imageIndex.sync="imageIndex" />
	</div>
</template>
  
<script>
import avatar from "@/assets/images/avatar.png";
import AppViewImg from "@/components/AppViewImg";
import { uploadHandle } from "@/utils";
import { mapGetters } from "vuex";
import UserService from "@/api/userService";

export default {
	name: "userInfo",
	components: { AppViewImg },
	data() {
		return {
			isEditStatus: false,
			imageList: [],
			imageIndex: 0,
			avatar,
			avatarUrl: undefined,
			userName: undefined,
		};
	},

	computed: {
		...mapGetters(["isManager", "userInfo"]),
		getBgStyle() {
			return function(thumbnail_url) {
				return {
					background: `url(${thumbnail_url}) no-repeat center center`,
				};
			};
		},
	},

	watch: {
		userInfo: {
			handler(value = {}) {
				this.avatarUrl = value.avatar_url;
				this.userName = value.name;
			},
			immediate: true,
			deep: true,
		},
	},

	methods: {
		viewPhoto(source, index = 0, type = "avatar_url") {
			if (!source[index][type] || !source[index][type].startsWith("http"))
				return;
			this.imageList = source
				.filter((item) => item[type] && item[type].startsWith("http"))
				.map((item) => item[type]);
			this.imageIndex = this.imageList.findIndex(
				(item) => item === source[index][type]
			);
		},

		customRequest(event) {
			uploadHandle({ file: event.file }).then((imageObj) => {
				this.avatarUrl = imageObj.url;
			});
		},

		updateUserInfo() {
			if (!this.userName || !this.userName.trim()) {
				this.$message.warning("姓名不能为空");
				return;
			}

			UserService.updateUserInfoService({
				name: this.userName.trim(),
				avatar_url: this.avatarUrl,
			})
				.then(() => {
					this.$message.success("操作成功");
					this.isEditStatus = false;
                    this.$store.dispatch("getUserInfoService");
				})
				.catch(() => {
					this.$message.error("操作失败，请重新操作");
				});
		},

		resetHandle() {
			this.avatarUrl = this.userInfo.avatar_url;
			this.userName = this.userInfo.name;
            this.isEditStatus = false;
		},
	},
};
</script>
  
<style lang="less" scoped>
.userInfo {
	&-container {
		margin-top: 15px;
		margin-right: 100px;
		background-color: #ffffff;

		/deep/.ant-upload-picture-card-wrapper {
			display: inline-block;
			width: auto;
		}

		/deep/.ant-upload-select-picture-card {
			background-color: #ffffff;
			border: none;
		}

		/deep/.ant-upload {
			margin: 0 !important;
			padding: 0 !important;
		}
	}

	&-content {
		display: flex;
		flex-flow: nowrap row;
	}

	&-title {
		display: flex;
		flex-flow: nowrap row;
		align-items: center;
		height: 32px;
		padding: 15px 0;
		box-sizing: content-box;
		line-height: 32px;
		background: #f0f2f5;

		&::before {
			position: relative;
			top: 0px;
			display: inline-block;
			content: "";
			width: 6px;
			height: 6px;
			margin-right: 8px;
			background: #409eff;
			border-radius: 50%;
		}
	}

	&-right {
		width: calc(100% - 190px);
	}

	&-label {
		display: block;
		height: 20px;
		margin: 22px 0 14px;
		font-size: 14px;
		color: #343c6a;
	}

	&-input {
		width: 360px;
		height: 32px;
		border-radius: 4px;
		border-color: #d5d5d5;
	}

	&-avatar {
		display: block;
		position: relative;
		width: 90px;
		height: 90px;
		margin: 40px 50px 0;
		border-radius: 50%;
		background: #ececee;
		font-size: 40px;
		line-height: 90px;
		overflow: hidden;
		background-size: cover !important;

		&_tips {
			text-align: center;
			color: #cccccc;
		}
	}

	&-item {
		width: 400px;
		margin: 22px 0;

		&_label {
			height: 20px;
			margin: 0 0 10px 0;
			font-size: 14px;
			line-height: 20px;
			color: #343c6a;
			font-weight: bold;
		}
	}
}
</style>
